import { store } from '@utils/configStore'
import { storeManagementReducer } from './slice'

export const injectStoreManagement = () => store.injectReducer('storeManagement', storeManagementReducer)
